/* eslint-disable max-lines-per-function */
/* eslint-disable no-invalid-this */
import React from "react";
import { omit } from "lodash";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { isInputValid } from "../form-utils";

const isNil = (value: any) => typeof value === "undefined" || value === null;

const propsToOmit = [
  "options",
  "formData",
  "onChangeAction",
  "onBlurAction",
  "persistTableName",
  "validationSchema",
];

export const SelectAutocomplete: React.FC<{
  name: string;
  margin: "none" | "dense";
  label: string;
  options: { label: string; value: string }[];
  onChangeAction?: (props: any, value: any) => void;
  onBlurAction?: (props: any) => void;
  validationSchema: any[];
  required?: boolean;
  defaultValue: string | null;
  value?: string | null;
  formData: any;
  size?: "small" | "medium";
  multiple?: boolean;
  filterOptions?: (options: string[], state: { inputValue: string }) => string[];
}> = (args) => {
  const props = {
    ...args,
    onChangeAction: args.onChangeAction ?? (() => null),
    onBlurAction: args.onBlurAction ?? (() => null),
    validationSchema: args.validationSchema ?? [],
  };
  const [errMsg, setErrMsg] = React.useState("");

  const handleBlur = () => {
    if (props.validationSchema.length > 0) {
      const [isValid, newErrMsg] = isInputValid(props);
      if (!isValid) setErrMsg(newErrMsg);
    }
    props.onBlurAction(props);
  };

  const newProps = omit(props, propsToOmit);
  const margin = props.margin || "dense";
  // prevent react from complaining about null values
  if (props.value === null) {
    newProps.value = "Select";
  } else if (props.defaultValue === null && !props.value) {
    newProps.defaultValue = null;
  } else if (isNil(props.defaultValue) && typeof props.value === "undefined") {
    newProps.defaultValue = null;
  }
  if (newProps.value) delete newProps.defaultValue;

  const options = props.options.map((option) => {
    if (typeof option !== "object") return { label: option, value: option };
    return option;
  });
  const optionsToSelect = options.map(({ value }) => value);
  const optionsMap = options.reduce((acc, item) =>
    ({ ...acc, [item.value]: item.label }), {}) as Record<string, string>;

  return (
    <Autocomplete
      margin={margin}
      id={props.name}
      onChange={(e) => props.onChangeAction(null, e)}
      onBlur={handleBlur}
      onFocus={() => setErrMsg("")}
      required={props.required}
      {...newProps}
      renderOption={(option) => optionsMap[option]}
      getOptionLabel={(option) => optionsMap[option] || ""}
      renderInput={(params) => <TextField
        {...params}
        name={props.name}
        label={props.label}
        margin={margin}
        variant="outlined"
        required={props.required}
        error={!!errMsg}
        size={props.size}
      />}
      options={optionsToSelect}
      multiple={props.multiple}
    />
  );
};

export default SelectAutocomplete;

